import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { initiateGlobalPriceChange } from "../api/initiateGlobalPriceChange";

export const useInitiateGlobalPriceChange = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => initiateGlobalPriceChange(body),
    onSuccess: (data) => {
      const result = data?.result;
      toast.success(
        `Global price change initiated! ${result?.affectedCount || 0} companies affected.`
      );
      queryClient.invalidateQueries({ queryKey: ["pendingPriceChanges"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to initiate global price change.");
    },
  });
};

